enum Types {
	boolean = 'boolean',
	number = 'number',
	string = 'string',
	object = 'object',
	function = 'function',
	undefined = 'undefined',
}

export const isUndefined = (argument: any) => typeof argument === Types.undefined;

export const isString = (argument: any) => typeof argument === Types.string;
export const isFunction = (fn: unknown): fn is Function => typeof fn === 'function';
export const isNull = (argument: any) => typeof argument === null;
